import { render, staticRenderFns } from "./LoginHeader.vue?vue&type=template&id=7ef531c2&scoped=true"
import script from "./LoginHeader.vue?vue&type=script&lang=ts"
export * from "./LoginHeader.vue?vue&type=script&lang=ts"
import style0 from "./LoginHeader.vue?vue&type=style&index=0&id=7ef531c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef531c2",
  null
  
)

export default component.exports